<template>
    <ToolButton :Editor="Editor" 
        KnownIcon="Italic" 
        @ToolClick="Editor.chain().focus().toggleItalic().run()"
        :class="{ 'toggled': Editor.isActive('italic') }">

    </ToolButton>
</template>
<script>

    import ToolButton from '@/views/components/atoms/tiptap/Predefined/Buttons/ToolButton.vue';

    export default({
        components:{
            ToolButton
        },
        props:["Editor"]
    });
</script>